import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import { Flex, Box } from 'reflexbox';

import { Button } from '../../../../components/Marketing/Button';
import { MARKETING_PAGE_BREAKPOINT_DESKTOP } from '../../../../components/Style/breakpoints';

const Wrapper = styled.div``;

const Container1 = styled(Flex)`
  flex-direction: column-reverse;
  margin-top: 40px;
  margin-bottom: 0px;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    justify-content: center;
    flex-direction: initial;
  }
`;

const Container2 = styled(Flex)`
  flex-direction: column-reverse;
  margin-top: 0px;
  margin-bottom: 40px;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    justify-content: center;
    flex-direction: initial;
  }
`;

const SubContainer = styled(Flex)`
  flex-direction: column;
  padding: 0px 15px;
  width: 100%;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    justify-content: center;
    // padding-left: 30px;
    width: 50%;
  }

  button {
    margin-bottom: 15px;
    text-align: left;
  }
`;

const ContainerInner = styled.div`
  max-width: 960px;
  width: 100%;
  flex-direction: column;
  display: flex;
  // padding: 2px;
  margin-bottom: 0px;

  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    flex-direction: row;
  }

  @media only screen and (min-width: 960px) {
    padding: 12px;
    > div {
      width: 50%;
    }
    > img {
      width: 50%;
    }
    margin-bottom: 0px;
  }
  img {
    display: none;
    @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
      display: block;
    }
  }
`;

const TextContainer = styled.div`
  max-width: 300px;
  display: flex;
  flex-direction: column;
  padding: 15px;
  margin-bottom: 0px;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    justify-content: center;
    // padding-left: 30px;
    width: 50%;
  }
`;

const Title = styled(Box)`
  font-weight: 900;
  font-size: 14px;
  line-height: 130%;
  color: #b0b6c2;
  padding-bottom: 12px;
`;

const Heading = styled.div`
  font-size: 26px;
  font-weight: 900;

  line-height: 120%;
  letter-spacing: -0.01em;
  color: #041416;

  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    font-size: 36px;
  }
`;

const SameSizeButton = styled(Button)`
  width: 100%;
`;

export const AllInOne2 = (): ReactElement => {
  return (
    <Wrapper>
      <Container1>
        <ContainerInner>
          <TextContainer>
            <Title>ALL-IN-ONE</Title>
            <Heading>The complete platform solution</Heading>
          </TextContainer>
        </ContainerInner>
      </Container1>

      <Container2>
        <ContainerInner>
          <SubContainer>
            <SameSizeButton
              variant="secondary"
              action={{
                kind: 'external_link',
                value:
                  'https://solutions.openlearning.com/platform-features/#student_engagement',
                target: '_blank',
              }}
            >
              Learner engagement
            </SameSizeButton>
            <SameSizeButton
              variant="secondary"
              action={{
                kind: 'external_link',
                value:
                  'https://solutions.openlearning.com/platform-features/#course_authoring',
                target: '_blank',
              }}
            >
              Course authoring
            </SameSizeButton>
            <SameSizeButton
              variant="secondary"
              action={{
                kind: 'external_link',
                value:
                  'https://solutions.openlearning.com/platform-features/#assessment',
                target: '_blank',
              }}
            >
              Assessment
            </SameSizeButton>
            <SameSizeButton
              variant="secondary"
              action={{
                kind: 'external_link',
                value:
                  'https://solutions.openlearning.com/platform-features/#assessment', // TODO: update link
                target: '_blank',
              }}
            >
              Portfolios
            </SameSizeButton>
            <SameSizeButton
              variant="secondary"
              action={{
                kind: 'external_link',
                value:
                  'https://solutions.openlearning.com/platform-features/#certification',
                target: '_blank',
              }}
            >
              Certification
            </SameSizeButton>
          </SubContainer>
          <SubContainer>
            <SameSizeButton
              variant="secondary"
              action={{
                kind: 'external_link',
                value: 'https://solutions.openlearning.com/opencreds/',
                target: '_blank',
              }}
            >
              OpenCreds
            </SameSizeButton>
            <SameSizeButton
              variant="secondary"
              action={{
                kind: 'external_link',
                value:
                  'https://solutions.openlearning.com/platform-features/#facilitation',
                target: '_blank',
              }}
            >
              Facilitation
            </SameSizeButton>
            <SameSizeButton
              variant="secondary"
              action={{
                kind: 'external_link',
                value:
                  'https://solutions.openlearning.com/platform-features/#learning_analytics',
                target: '_blank',
              }}
            >
              Learning analytics
            </SameSizeButton>
            <SameSizeButton
              variant="secondary"
              action={{
                kind: 'external_link',
                value:
                  'https://solutions.openlearning.com/platform-features/#portal_exclusive_features',
                target: '_blank',
              }}
            >
              Institutional Portals
            </SameSizeButton>
            <SameSizeButton
              variant="secondary"
              action={{
                kind: 'external_link',
                value: 'https://solutions.openlearning.com/marketing/',
                target: '_blank',
              }}
            >
              Marketing
            </SameSizeButton>
          </SubContainer>
        </ContainerInner>
      </Container2>
    </Wrapper>
  );
};
